import { useEffect, useState, useCallback } from "react";

import AsyncSelect from "react-select/async";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const asyncSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 34,
    fontSize: 14,
  }),
};

export default function CampaignProductsTab(props) {
  const {
    getProductsForDropdown,
    campaignProducts,
    addCampaignProduct,
    removeCampaignProduct,
    getCampaignProducts,
    campaignId,
  } = props;

  const [asyncSelectValue, setAsyncSelectValue] = useState(null);

  useEffect(() => {
    if (campaignId) {
      getCampaignProducts(campaignId);
    }
  }, [campaignId]);

  const loadOptions = async (input, callback) => {
    if (input.length < 2) {
      callback([]);
      return;
    }
    const result = await getProductsForDropdown(input, 1);
    const list = Array.isArray(result) ? result : result?.data ?? [];
    callback(list);
  };

  const handleSelectProduct = (option) => {
    if (option && campaignId) {
      addCampaignProduct(campaignId, option, 1);
      setAsyncSelectValue(null);
    }
  };

  const productBody = useCallback((rowData) => {
    const p = rowData.product;
    return (
      <span className="font-medium text-gray-900">
        {p.name_en}
        {p.plu ? ` (${p.plu})` : ""}
      </span>
    );
  }, []);

  const actionBody = useCallback(
    (rowData) => (
      <button
        type="button"
        className="text-red-600 hover:text-red-800 text-sm font-medium"
        onClick={() => removeCampaignProduct(rowData.id ?? rowData.product.id)}
      >
        Remove
      </button>
    ),
    [removeCampaignProduct]
  );

  return (
    <div className="-mt-2 bg-white px-4 py-6">
      <h2 className="text-base font-semibold leading-6 text-gray-900">
        Campaign Products
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Search for products and click one to add it to this campaign.
      </p>

      {/* Search with AsyncSelect (same pattern as CreateNewOrderForm) */}
      <div className="mt-4">
        <AsyncSelect
          cacheOptions
          loadOptions={loadOptions}
          getOptionLabel={(option) =>
            `${option.name_en || ""}${option.plu ? ` (${option.plu})` : ""}`
          }
          getOptionValue={(option) => option.id}
          value={asyncSelectValue}
          onChange={handleSelectProduct}
          placeholder="Search by name or PLU (type 2+ characters)"
          noOptionsMessage={() => "Type to search for products"}
          styles={asyncSelectStyles}
          className="w-full"
        />
      </div>

      {/* List of products in campaign - DataTable (same as Campaigns list / OrderProductsTable) */}
      <div className="mt-8">
        <h3 className="text-sm font-semibold leading-6 text-gray-900">
          Products in this campaign
        </h3>
        <div className="mt-2 overflow-hidden card-custom">
          {campaignProducts.length === 0 ? (
            <div className="py-6 text-center text-gray-500 text-sm">
              No products added yet.
            </div>
          ) : (
            <DataTable
              value={campaignProducts}
              dataKey="product.id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
              cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
            >
              <Column
                header="Product"
                body={productBody}
                headerStyle={{ width: "75%" }}
              />
              <Column header="" body={actionBody} headerStyle={{ width: "25%" }} />
            </DataTable>
          )}
        </div>
      </div>
    </div>
  );
}
